<template>
	<nav class="navbar navbar-main navbar-expand-lg sticky-top hidden-sm composition-nav-wrapper">
		<div class="container-fluid">
			<router-link class="navbar-brand" to="/">
				<img src="/img/icon-512.png" class="d-inline-block align-top" alt="Grafias">
			</router-link>
			<div class="navbar-separator"></div>
			<div class="nav-page-title">{{ title }}</div>
			<button type="button" class="navbar-toggler">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="main-nav-dropdown collapse navbar-collapse justify-content-between">
				<ul class="navbar-nav">
					<li class="nav-item hidden" :class="{ 'active': isMenuActive('/') }">
						<router-link class="nav-link nav-link-text" to="/">
							<!-- <span class="link-label">{{ $t('menu.home') }}</span> -->
						</router-link>
					</li>
				</ul>

				<ul class="navbar-nav">
					<li class="clock-time">
						{{ clockTime }}
					</li>
					<li>
						<button
							@click="save()"
							class="btn btn-primary text-white mt-2"
							to="/program-monitor">
							{{ $t('Save & Exit') }}
						</button>
					</li>
					<li>
						<profile-dropdown class="pl-3"></profile-dropdown>
					</li>

					<li class="nav-item dropdown profile-menu hidden" v-if="user">
						<div class="nav-link p-0">
							<md-menu md-size="big" md-direction="bottom-end" md-align-trigger>
								<md-button class="btn-fluid ml-3" v-tooltip="fullname" :md-ripple="false" md-menu-trigger>
									<div class="flex-center-left">
										<span class="mr-2 pt-1">{{ user.name }}</span>
										<div
											class="profile-image"
											:style="{ backgroundImage: `url('${user.picture}')` }"
											v-if="user.picture && user.picture !== ''">
										</div>
										<i class="material-icons profile-image" v-else>account_circle</i>
									</div>
								</md-button>
								<md-menu-content>
									<md-menu-item @click="$router.push('/profile')">{{ $t('Profile') }}</md-menu-item>
									<md-menu-item @click="logout()">{{ $t('Logout') }}</md-menu-item>
								</md-menu-content>
							</md-menu>
						</div>
					</li>
					<!-- Help -->
					<li class="nav-item m-0 hidden">
						<a class="nav-link help-toggle cur-p" v-tooltip="$t('Help')" @click="showHelp">
							<div class="help-icon icon-toggle">
								<i class="material-icons">help</i>
							</div>
							<!-- <div class="label ml-2">Help</div> -->
						</a>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProfileDropdown from './ProfileDropdown.vue';


export default {
	name: 'mainNav',
	components: {
		ProfileDropdown,
	},
	data() {
		return {
			shrink: false,
			clockTime: '',
		};
	},
	methods: {
		...mapActions({
			logout: 'logout',
			switchRole: 'switchRole',
			setSwitcherState: 'setSwitcherState',
			setHelpState: 'setHelpState',
		}),
		save() {
			this.$emit('saveAndExit');
		},
		handleScroll() {
			const scrollPosition = window.scrollY;
			const treshold = 0;
			if (scrollPosition > treshold) {
				this.shrink = true;
			} else {
				this.shrink = false;
			}
		},
		isUserCan(capability) {
			return this.user && this.user.capabilities.includes(capability);
		},
		showHelp() {
			this.setHelpState(true);
		},
		updateTime() {
			const cd = new Date();
			this.clockTime = `${this.zeroPadding(cd.getHours(), 2)}:${this.zeroPadding(cd.getMinutes(), 2)}:${this.zeroPadding(cd.getSeconds(), 2)}`;
		},

		zeroPadding(num, digit) {
			let zero = '';
			for (let i = 0; i < digit; i++) {
				zero += '0';
			}
			return (zero + num).slice(-digit);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			role: 'role',
			isMenuActive: 'isMenuActive',
		}),
		fullname() {
			return this.user.name;
		},
		roles() {
			return this.user ? this.user.roles : [];
		},
		title() {
			return this.$route.meta.gtm || 'Grafias';
		},
	},
	created() {
		window.addEventListener('scroll', this.handleScroll);
		// eslint-disable-next-line no-unused-vars
		const timerId = setInterval(this.updateTime, 1000);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>
